import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import ReactCountryFlag from 'react-country-flag';
import { CalendarIcon, DeleteIcon, EditIcon } from '../../../assets/icons';
import {
  BookingFormType,
  BookingType,
} from '../../../redux/types/bookingTypes';
import { ButtonType, ModalWindowTypes } from '../../../utils/@globalTypes';
import {
  BookingSelectors,
  removeBooking,
} from '../../../redux/reducers/bookingSlice';
import { CalendarIcon2 } from '../../../assets/icons';
import { setModalWindowData } from '../../../redux/reducers/pageSlice';
import Button from '../../Button';
import ColorBannerPaid from '../ColorBannerPaid';
import { getBookingIcon } from '../functions';

import styles from './ListItem.module.scss';
import classNames from 'classnames';
import { RoutesList } from '../../../App';

type ItemProps = {
  booking: BookingType;
};

const ListItem = ({ booking }: ItemProps) => {
  const {
    accommodation_price,
    total_board_price,
    total_animal_price,
    paid,
    check_out_date,
    check_in_date,
    status,
    id,
    first_name,
    last_name,
    nationality,
    rental_object,
    viewed,
  } = booking;

  const dispatch = useDispatch();

  const onDeleteBtnClick = () => {
    dispatch(removeBooking(id));
  };
  const icon = getBookingIcon(status);
  const objects = useSelector(BookingSelectors.getChessObjects);
  const res = objects?.find((item) =>
    item.rental_objects.find((obj) => obj.id === rental_object),
  );

  const object =
    res && res.rental_objects.find((item) => item.id === rental_object);

  const isReadyToDelete =
    moment(check_out_date).startOf('day').unix() <
      moment(new Date()).startOf('day').unix() || status === 'cld';

  const handlerViewBooking = () => {
    dispatch(
      setModalWindowData({
        type: ModalWindowTypes.SHOW_RESERVATION,
        data: { type: BookingFormType.view, booking: booking },
      }),
    );
  };
  const handlerEditBooking = (): void => {
    dispatch(
      setModalWindowData({
        type: ModalWindowTypes.SHOW_RESERVATION,
        data: { type: BookingFormType.edit, booking: booking },
      }),
    );
  };

  const onChessBtnClick = () => {
    localStorage.setItem('chess', check_in_date);
  };
  const totalCost = (
    Number(accommodation_price) +
    Number(total_board_price) +
    Number(total_animal_price)
  ).toString();
  return (
    <div
      className={classNames(styles.container, {
        [styles.notViewed]: !viewed,
      })}
    >
      <div className={styles.left} onClick={handlerViewBooking}>
        <div className={styles.info}>
          <div className={styles.objectBlock}>
            <div className={styles.icon}>{icon}</div>
            <div className={styles.rent}>{object && object.name}</div>
          </div>

          <div className={styles.personBlock}>
            <div className={styles.names}>
              <span className={styles.flag}>
                <ReactCountryFlag
                  svg
                  countryCode={nationality}
                  style={{
                    width: '1.8em',
                    height: '1.33em',
                  }}
                />
              </span>
              <div className={styles.container_names}>
                <span className={styles.last_name}>{last_name}</span>{' '}
                <span className={styles.last_name}>{first_name}</span>
              </div>
            </div>
            <div className={styles.dates}>
              <div className={styles.dates_left}>
                <CalendarIcon2 />
                <span className={styles.date}>
                  {moment(check_in_date).format('DD.MM.YYYY')}
                </span>
              </div>
              <div className={styles.dates_right}>
                {' '}
                &mdash;{' '}
                <span className={styles.date}>
                  {moment(check_out_date).format('DD.MM.YYYY')}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.banner}>
          <ColorBannerPaid
            total={totalCost}
            paid={paid}
            status={status}
            check_out_date={check_out_date}
          />
        </div>
      </div>
      <div className={styles.right}>
        <Button
          type={ButtonType.SMALL}
          title={<EditIcon />}
          onClick={handlerEditBooking}
        />
        <div className={styles.chessBtn} onClick={onChessBtnClick}>
          <Button
            type={ButtonType.SMALL}
            title={<CalendarIcon2 fill="#8692A6" width="26" height="26" />}
            wrapperClassName="bookingList"
            isStrokeIcon
            path={RoutesList.checkerboard.fullPath}
          />
        </div>
        <div className={styles.delete}>
          <Button
            type={ButtonType.SMALL}
            title={<DeleteIcon />}
            className="deleteBookingList"
            wrapperClassName="bookingList"
            windowClassName="bookingConfirm"
            onClick={onDeleteBtnClick}
            disabled={!isReadyToDelete}
            confirmWindowText="Вы действительно хотите удалить бронь?"
          />
        </div>
        {!isReadyToDelete && (
          <div className={styles.help}>
            Для удаления брони необходимо изменить ее статус на "Отменена"
          </div>
        )}
      </div>
    </div>
  );
};

export default ListItem;
